import { render, staticRenderFns } from "./AppPermissionAlert.vue?vue&type=template&id=0da2560c&scoped=true&"
import script from "./AppPermissionAlert.vue?vue&type=script&lang=js&"
export * from "./AppPermissionAlert.vue?vue&type=script&lang=js&"
import style0 from "./AppPermissionAlert.vue?vue&type=style&index=0&id=0da2560c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2560c",
  null
  
)

export default component.exports